export interface IService {
}

export abstract class BaseService implements IService {
    constructor() {
    }
}
